/* src/app/pages/results/monthly-report/monthly-reports.component.scss */
.default-flex-start {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}
.default-flex-end {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.default-flex-between {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.default-flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.default-flex-column {
  display: flex;
  flex-flow: column;
}
.default-flex-stretch {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  align-content: stretch;
}
.rounded-circle {
  border-radius: 50%;
}
:host {
  --cds-info-400: var(--cds-text-medium);
  display: flex;
  flex-direction: column;
  padding: 32px 24px;
}
:host ::ng-deep bfm-monthly {
  padding: 24px 16px !important;
  background: var(--cds-background-main);
  border-radius: 4px;
  margin: 24px 0px;
}
:host ::ng-deep bfm-monthly .list-header h2 {
  color: var(--cds-primary-500);
  font-weight: 700;
}
:host ::ng-deep bfm-monthly .text-container h4:nth-child(2) {
  display: none;
}
:host ::ng-deep bfm-monthly .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td:nth-child(4) {
  color: var(--cds-revenue) !important;
  font-weight: 600 !important;
}
:host ::ng-deep bfm-monthly .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td:nth-child(4) {
  color: var(--cds-expense) !important;
  font-weight: 600 !important;
}
:host ::ng-deep bfm-results-period-filter .titles h6 {
  font-size: 16px !important;
  font-weight: 600 !important;
}
:host ::ng-deep bfm-toggle-results-tabs {
  width: 100% !important;
}
:host ::ng-deep bfm-toggle-results-buttons .buttons-row button {
  font-family: var(--cds-font-family);
  font-size: 12px;
  font-weight: 600;
  color: var(--cds-primary-500);
  line-height: 1.5;
}
:host ::ng-deep .results-accordion-header .result-column {
  background: var(--cds-background-accent) !important;
}
:host ::ng-deep cds-no-content {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 24px;
}
:host ::ng-deep .chart-of-account {
  grid-template-columns: 1fr 1fr !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) h4 {
  color: var(--cds-revenue) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) h4.c-revenue {
  font-weight: 600 !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr {
  display: grid !important;
  grid-template-columns: 0px 2fr 1fr 1fr 1fr !important;
  width: unset !important;
  border: none !important;
  margin-bottom: 10px;
  padding: 0px 10px !important;
  background: var(--cds-foreground-20);
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td {
  align-self: center;
  justify-self: end;
  font-size: 16px !important;
  color: var(--cds-text-strong) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td:nth-child(1) {
  padding-left: 5px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td:nth-child(2) {
  justify-self: start;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td + .icons-row {
  gap: 24px;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr td + .icons-row i {
  font-size: 14px;
  color: var(--cds-revenue) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:first-child {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:not(:last-child):not(:first-child) {
  display: grid !important;
  grid-template-columns: 30px 2fr 1fr 1fr 1fr !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:not(:last-child):not(:first-child) .c-revenue {
  color: var(--cds-revenue) !important;
  font-weight: 600 !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child {
  grid-template-columns: 0px 8.1fr 1fr 1fr 0fr !important;
  background: transparent !important;
  margin-bottom: 0px;
  padding: 0px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child td {
  font-weight: 700 !important;
  font-size: 18px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child td:nth-child(1) {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child td:nth-child(2) {
  border-left: 5px solid var(--cds-revenue) !important;
  padding-left: 5px !important;
  color: var(--cds-text-medium) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child td:nth-child(3) {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(1) bfm-coa-value-list table tr:last-child td:nth-child(4) {
  color: var(--cds-revenue) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) h4 {
  color: var(--cds-expense) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) h4.c-revenue {
  font-weight: 600 !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr {
  display: grid !important;
  grid-template-columns: 0px 2fr 1fr 1fr 1fr !important;
  width: unset !important;
  border: none !important;
  margin-bottom: 10px;
  padding: 0px 10px !important;
  background: var(--cds-foreground-20);
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td {
  align-self: center;
  justify-self: end;
  font-size: 16px !important;
  color: var(--cds-text-strong) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td:nth-child(1) {
  padding-left: 5px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td:nth-child(2) {
  justify-self: start;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td + .icons-row {
  gap: 24px;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr td + .icons-row i {
  font-size: 14px;
  color: var(--cds-expense) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:first-child {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:not(:last-child):not(:first-child) {
  display: grid !important;
  grid-template-columns: 30px 2fr 1fr 1fr 1fr !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:not(:last-child):not(:first-child) .c-revenue {
  color: var(--cds-expense) !important;
  font-weight: 600 !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child {
  grid-template-columns: 0px 8.1fr 1fr 1fr 0fr !important;
  background: transparent !important;
  margin-bottom: 0px;
  padding: 0px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child td {
  font-weight: 700 !important;
  font-size: 18px !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child td:nth-child(1) {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child td:nth-child(2) {
  border-left: 5px solid var(--cds-expense) !important;
  padding-left: 5px !important;
  color: var(--cds-text-medium) !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child td:nth-child(3) {
  display: none !important;
}
:host ::ng-deep .chart-of-account .coa-column:nth-child(2) bfm-coa-value-list table tr:last-child td:nth-child(4) {
  color: var(--cds-expense) !important;
}
:host ::ng-deep .cds-tabs-wrapper {
  gap: 32px !important;
  justify-content: flex-start !important;
  border-bottom: 1.5px solid var(--cds-border);
}
:host ::ng-deep cds-tab label {
  padding: 0 32px !important;
  display: block;
}
:host ::ng-deep cds-tab input[type=radio]:checked {
  background: var(--cds-tab-checked-color);
}
:host ::ng-deep cds-tab input[type=radio]:checked ~ label {
  border-bottom: 2px solid var(--cds-tab-checked-color);
  color: var(--cds-tab-checked-color) !important;
  font-weight: 600 !important;
}
:host ::ng-deep cds-tab input[type=radio]:checked ~ label::after {
  background: none !important;
}
:host ::ng-deep .accordion-body-tooltip {
  border-radius: 0px !important;
}
:host ::ng-deep .accordion-body {
  box-shadow: none !important;
  border: 1px solid var(--cds-border) !important;
  border-top: none !important;
}
:host ::ng-deep .accordion-description {
  font-family: var(--cds-font-family);
  font-size: 14px;
  font-weight: 400;
  color: var(--cds-text-medium);
  line-height: 1.5;
  color: var(--cds-text-medium) !important;
}
:host ::ng-deep .accordion-description > strong {
  color: var(--cds-text-primary);
}
:host ::ng-deep cdk-accordion > cdk-accordion-item:nth-child(12) > main {
  border: none !important;
  border-bottom: 2px solid var(--cds-border) !important;
  padding-bottom: 24px !important;
  margin-bottom: 24px !important;
}
:host ::ng-deep cdk-accordion-item div {
  margin-left: 0px !important;
  gap: 0px !important;
}
:host ::ng-deep cdk-accordion-item div ::before {
  background: transparent !important;
  width: 0px !important;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main:not(.header) {
  background: transparent !important;
  border: none;
  margin: 0;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.header {
  border-radius: 5px !important;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.category {
  grid-template-columns: calc(33.33% - 10px) calc(33.33% + 25px) calc(33.33% - 25px) !important;
  padding: 0;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.category section {
  font-weight: 500 !important;
  color: var(--cds-text-medium) !important;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.sub-category {
  padding: 0 30px;
  grid-template-columns: calc(33.33% - 10px) calc(33.33% + 30px) calc(33.33% + 10px) !important;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.sub-category .third-column strong {
  color: var(--cds-text-medium) !important;
  font-weight: 600;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.aux-category {
  padding: 0 60px;
  grid-template-columns: calc(33.33% - 10px) calc(33.33% + 25px) calc(33.33% - 25px) !important;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item main.aux-category .third-column strong {
  color: var(--cds-text-medium) !important;
  font-weight: 600;
}
:host ::ng-deep cdk-accordion-item bfm-results-accordion-item.c-info-400 .header .third-column strong {
  color: var(--cds-revenue);
}
::ng-deep bfm-coa-value .records-preview h2 {
  color: var(--cds-primary-500) !important;
  font-weight: 700 !important;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped .financial-record-header {
  background-color: var(--cds-foreground-20);
  height: 80px;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped .financial-record-header h5 {
  font-weight: 600 !important;
  color: var(--cds-text-strong) !important;
  font-size: 16px !important;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .value.c-text-medium {
  --color: var(--cds-primary-500);
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .cds-icon-filled-check {
  color: var(--cds-revenue);
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .cds-icon-filled-clock {
  color: var(--cds-text-light);
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .cds-icon-filled-alert-triangle {
  color: var(--cds-expense);
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row i.cds-icon-search {
  color: var(--cds-primary-500);
  right: initial;
  left: 4px;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .status {
  justify-content: center !important;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row .coa_name {
  color: var(--cds-text-medium) !important;
}
::ng-deep bfm-coa-value .records-preview bfm-financial-records-list ul.striped bfm-list-item .striped-row:nth-child(even) {
  background: var(--cds-foreground-20);
}
/*# sourceMappingURL=monthly-reports.component.css.map */
